export interface ContentCategory {
  name: string;
  premiumCategoryId?: number;
  primaryTopicId?: number;
}

export interface PrimaryPostDetails {
  name: string;
  primaryPostTagId?: number;
  primarySectionId?: number;
  link: string;
  uri: string;
  disablePage?: boolean;
}

export enum PageType {
  NoType = '',
  Article = 'article',
  ArticleV2 = 'article-v2',
  BrandedArticle = 'branded-article',
  Longform = 'longform',
  Company = 'company',
  EarningsReport = 'earnings_report',
  EzNewswireList = 'ez_newswire_list',
  EzNewswireArticle = 'ez_newswire_article',
  CompanyV2 = 'company-v2',
  Fortune500QaArticle = 'f500_qa',
  FranchiseList = 'franchise-list',
  FranchiseListSearch = 'franchise-list-search',
  FranchiseListItem = 'franchise-list-item',
  FranchiseListItemCompany = 'franchise-list-item-company',
  Franchise = 'franchise',
  Page = 'page',
  MainHomepage = 'mainHomepage',
  Homepage = 'homepage',
  Section = 'section',
  SponsoredPage = 'sponsored-page',
  StaticPage = 'static-page',
  Subscriptions = 'subscriptions',
  Topic = 'topic',
  Tag = 'tag',
  Magazine = 'magazine',
  Package = 'package',
  Packages = 'packages',
  Author = 'author',
  Rankings = 'rankings',
  Hub = 'hub',
  GuideHub = 'guide hub',
  Guide = 'guide',
  Evergreen = 'evergreen',
  Latest = 'latest',
  Person = 'person',
  EduChildRankingList = 'edu-child-rankings-list',
  EduRankingList = 'edu-rankings-list',
  EduSchool = 'edu-school',
  EduCategory = 'edu-category',
  Sitemap = 'sitemap',
  SitemapHome = 'sitemap-home',
  InteractiveTool = 'interactive-tool',
}
